import React, { useEffect, useState } from "react";
import BreadCrumb from "common/breadcrumb";

import Tab from "common/components/tab/tab";
import { Nav } from "common/components/tab/nav";

import { BrandingData } from "admin-portal/settings/branding";
import { useLocation } from "react-router-dom";

import { AppDispatch } from "slices/store";
import { useAppSelector, useAppDispatch } from "slices/hook";
import { getAuthState } from "slices/auth/login/reducer";

import { Customer } from "../../models/customer/customer";
import SearchCustomerComponent from "admin-portal/customer/search-customer";
import AddEditCustomerComponent from "admin-portal/customer/add-customer";

const CustomersPage = () => {
  const dispatch: AppDispatch = useAppDispatch();
  const { loggedInuser } = useAppSelector(getAuthState);

  // Retrieve query parameters
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const customerId = searchParams.get("id");

  const [loading, setLoading] = useState(false);
  const [addedCustomer, setAddedCustomer] = useState<Customer>();
  const [editedCustomer, setEditedCustomer] = useState<Customer>();
  const [activeTab, setActiveTab] = React.useState<string>("tab-customers");

  const [reloadCustomer, setReloadCustomer] = useState(0);

  // Effect to set the default tab based on the presence of customerId
  useEffect(() => {
    if (customerId) {
      setActiveTab("tab-edit-customer");
    }
  }, [customerId]);

  const handleTabSelect = (eventKey: string | null) => {
    if (eventKey === "tab-add-customer" || eventKey === "tab-edit-customer") {
      // This is where you can force Component to refresh data
      // For example, you can set a state that triggers a refresh
      // setVehicle((prev) => ({ ...prev, refresh: true }));
    }
    setActiveTab(eventKey || "tab-customers");
  };

  const onCustomerSave = (c: Customer) => {
    setEditedCustomer(undefined);
    setAddedCustomer({ ...c });
    setReloadCustomer(reloadCustomer + 1);
    setActiveTab("tab-customers");
  };
  const onCustomerEditClick = (c: Customer) => {
    setEditedCustomer({ ...c });
    setActiveTab("tab-add-customer");
  };

  const tenantId = loggedInuser?.activeTenantId;

  return (
    <React.Fragment>
      <BreadCrumb title={"Customers"} pageTitle={BrandingData.bussinessDomain + " Manage"} />
      <div className="grid grid-cols-1 xl:grid-cols-12 gap-x-5">
        <div className="xl:col-span-12">
          <div className="card">
            <div className="card-body">
              <Tab.Container defaultActiveKey={activeTab} onTabChange={handleTabSelect} activeTabKey={activeTab}>
                <Nav className="flex flex-wrap w-full text-sm font-medium text-center border-b border-slate-200 dark:border-zink-500 nav-tabs">
                  <Nav.Item eventKey="tab-customers" className="group">
                    <a
                      /*   href={`#${RoutePath.Admin_TenantEdit}`} */
                      data-tab-toggle
                      data-target="tab-customers"
                      className="inline-block px-4 py-2 text-base transition-all duration-300 ease-linear rounded-t-md text-slate-500 dark:text-zink-200 border-b border-transparent group-[.active]:text-custom-500 group-[.active]:border-b-custom-500 hover:text-custom-500 active:text-custom-500 dark:hover:text-custom-500 dark:active:text-custom-500 dark:group-[.active]:hover:text-custom-500 -mb-[1px]"
                    >
                      Search
                    </a>
                  </Nav.Item>
                  {editedCustomer && (
                    <Nav.Item eventKey="tab-add-customer" className="group">
                      <a
                        data-tab-toggle
                        data-target="tab-add-customer"
                        className="inline-block px-4 py-2 text-base transition-all duration-300 ease-linear rounded-t-md text-slate-500 dark:text-zink-200 border-b border-transparent group-[.active]:text-custom-500 group-[.active]:border-b-custom-500 hover:text-custom-500 active:text-custom-500 dark:hover:text-custom-500 dark:active:text-custom-500 dark:group-[.active]:hover:text-custom-500 -mb-[1px]"
                      >
                        {editedCustomer != null ? "Edit" : "Add"} Customer
                      </a>
                    </Nav.Item>
                  )}
                </Nav>

                <Tab.Content className="mt-5 tab-content">
                  <Tab.Pane eventKey="tab-customers" id="tab-customers">
                    <div className="mb-0">
                      <SearchCustomerComponent
                        onCustomerEditClick={onCustomerEditClick}
                        reload={reloadCustomer}
                      ></SearchCustomerComponent>
                    </div>
                  </Tab.Pane>

                  <Tab.Pane eventKey="tab-add-customer" id="tab-add-customer">
                    <div className="mb-0">
                      <AddEditCustomerComponent
                        customer={editedCustomer}
                        onCustomerSaveSuccess={onCustomerSave}
                      ></AddEditCustomerComponent>
                    </div>
                  </Tab.Pane>
                </Tab.Content>
              </Tab.Container>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default CustomersPage;
